import React from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody, Button } from "reactstrap";
import Game from "~/services/games";


const LimitedGameModal = ({isModalOpen, setModalOpen, item, limits})=> {

  const closeModal = ()=> setModalOpen(false);

  return(
    <Modal isOpen={isModalOpen} toggle={closeModal} centered>

      <ModalHeader toggle={closeModal}> {item.name} </ModalHeader>

      <ModalBody> {Game.getLimititationSentence(item, limits)} </ModalBody>

      <ModalFooter className="jc-center">
        <Button color="danger" className="pull-left" onClick={()=> setModalOpen(false)}> Cancel </Button>
      </ModalFooter>

    </Modal>
  );

}

export default LimitedGameModal;
